import script from "./tabel.vue?vue&type=script&lang=ts&setup=true"
export * from "./tabel.vue?vue&type=script&lang=ts&setup=true"

import "./tabel.vue?vue&type=style&index=0&id=1bcafd24&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bcafd24"]])

export default __exports__